
    export interface IEditApprovedRequest {
        email: string;
        approved: boolean;
    }

    export class EditApprovedRequest implements IEditApprovedRequest {
        email: string;
        approved: boolean;
    }